import { render } from "./PlatformHome.vue?vue&type=template&id=b6ee80d6&scoped=true"
import script from "./PlatformHome.vue?vue&type=script&lang=js"
export * from "./PlatformHome.vue?vue&type=script&lang=js"

import "./PlatformHome.vue?vue&type=style&index=0&id=b6ee80d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ee80d6"]])

export default __exports__